module.exports = __webpack_public_path__ + "static/media/ic_empty_notif.a96430a7.svg";